var App = App || {};

App.ClutchUtmTracking = (() => {
    'use strict';

    const utmKeys = [
        'utm_source',
        'utm_medium',
        'utm_campaign'
    ];

    const init = () => {
       
        captureUtmParameters();
        updateClutchLinks();
    };

    const captureUtmParameters = () => {
        const currentParams = new URLSearchParams(window.location.search);

        utmKeys.forEach((key) => {
            const value = currentParams.get(key);

            if (value) {
                localStorage.setItem(key, value);
            }
        });
    };

    const updateClutchLinks = () => {
        document.querySelectorAll('a[href]').forEach((link) => {
            try {
                const url = new URL(link.href, window.location.origin);

                if (!isClutchLink(url)) {
                    return;
                }

                utmKeys.forEach((key) => {
                    const value = localStorage.getItem(key);

                    if (value) {
                        url.searchParams.set(key, value);
                    }
                });

                link.href = url.toString();
            }
            catch (e) {
                
            }
        });
    };

    const isClutchLink = (url) => {
        
        return url.hostname.includes('clutch') ||
            url.hostname.includes('apply.kpcu');
    };

    return {
        init,
    };
})(jQuery);